import { AmsRequestKeys, AmsSearchRequest, DeliveryOption } from '../../services/amsSearch/amsSearch.interface'

export const getFilterCount = (request: AmsSearchRequest | null) => {
    if (!request) return 0

    // One filter is always set for the location + radius and cannot be unset
    let counter = 1

    counter += [request[AmsRequestKeys.MakeId], request[AmsRequestKeys.ModelId]].filter((value) => value.length).length

    counter += [
        request[AmsRequestKeys.PriceMin],
        request[AmsRequestKeys.PriceMax],
        request[AmsRequestKeys.FirstRegistrationDateMin],
        request[AmsRequestKeys.FirstRegistrationDateMax],
        request[AmsRequestKeys.MileageMin],
        request[AmsRequestKeys.MileageMax],
        request[AmsRequestKeys.HpMin],
        request[AmsRequestKeys.HpMax],
        request[AmsRequestKeys.KwMin],
        request[AmsRequestKeys.KwMax],
        // both seatsMin and seatsMax get set when selecting a value,
        // but they only count as one filter.
        request[AmsRequestKeys.SeatsMin],
        // Same for doorsMin and doorsMax
        request[AmsRequestKeys.DoorsMin],
    ].filter((value) => value !== null).length

    // Each checkbox is a separate filter, so we combine all the checkbox
    // filter arrays into one array and add the length to the counter
    counter += [
        request[AmsRequestKeys.OfferType],
        request[AmsRequestKeys.BodyType],
        request[AmsRequestKeys.Fuel],
        request[AmsRequestKeys.TransmissionType],
        request[AmsRequestKeys.EmissionClass],
        request[AmsRequestKeys.Equipment],
        request[AmsRequestKeys.BodyColor],
    ].flat().length

    if (request[AmsRequestKeys.DeliveryOption] !== DeliveryOption.All) {
        counter++
    }

    return counter
}
